<template>
    <div class="noResult">
        <div class="nrIcon">
            <img src="@/assets/common/ri_search-line.png" alt="" />
        </div>
        <div class="nrTitle">검색 결과가 없습니다.</div>
        <div class="nrContent">
            {{ props.content ? props.content : "검색어를 잘못 기입했거나 아직 검색결과가 없을 수 있습니다." }}
        </div>
    </div>
</template>
<script lang="ts" config>
    export default {
        props: ["content"],
        components: {},
        setup(props: any) {
            return {
                props,
            };
        },
    };
</script>
